import { getAllSeries } from "./seriesUtils";

export function isTitleDuplicate(title) {
  const all = getAllSeries();
  return all.some((s) => s.title.trim().toLowerCase() === title.trim().toLowerCase());
}

function wordOverlapRatio(textA = "", textB = "") {
  const wordsA = textA
    .toLowerCase()
    .replace(/[^a-z0-9áéíóúñü\s]/gi, "")
    .split(/\s+/)
    .filter((w) => w.length > 2);

  const wordsB = textB
    .toLowerCase()
    .replace(/[^a-z0-9áéíóúñü\s]/gi, "")
    .split(/\s+/)
    .filter((w) => w.length > 2);

  if (wordsA.length === 0 || wordsB.length === 0) return 0;

  const setA = new Set(wordsA);
  const setB = new Set(wordsB);
  let common = 0;
  setA.forEach((word) => {
    if (setB.has(word)) common++;
  });

  const minLen = Math.min(setA.size, setB.size);
  return common / minLen;
}

export function hasSynopsisTooSimilar(newSynopsis, threshold = 0.5) {
  const all = getAllSeries();
  for (const serie of all) {
    const ratio = wordOverlapRatio(newSynopsis, serie.synopsis);
    if (ratio >= threshold) {
      return {
        suspicious: true,
        existingTitle: serie.title,
        ratio,
      };
    }
  }
  return { suspicious: false };
}